/* global BX */
/* global $ */

import axios from 'axios';

export default {
    data: function () {
        return {}
    },
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        dataLoaded: {
            type: Boolean,
            default: false
        },
        selectedYear: {
            type: Number
        },
        selectedMonth: {
            type: Number
        },
        sessid: {
            type: String,
            default: BX.bitrix_sessid()
        },
        sections: {
            type: Object,
            default() {
                return {}
            }
        },
        eventsMap: {
            type: Object,
            default() {
                return {}
            }
        },
        events: {
            type: Object,
            default() {
                return {}
            }
        },
        sectionCss: {
            type: Object,
            default() {
                return {
                    'mango_events': 'mango',
                    'external_events': '',
                    'partner_events': 'partners',
                    'client_events': 'clients'
                };
            }
        },
        nowDate: {
            type: Date
        },
        filter: {
            type: Array,
            default() {
                return []
            }
        },
        ids: {
            type: Array,
            default() {
                return []
            }
        },
        detailLoaded: {
            type: Boolean,
            default: false,
        },
        detailEvent: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    methods: {
        request() {
            let params = {
                sessid: this.sessid
            };
            const t = this;
            this.apiUrl = '/api/calendar/';
            this.$api.request(this.apiUrl, 'get', params)
                .then((r) => {
                    t.eventsMap = r.data.EVENTS_MAP;
                    t.events = r.data.EVENTS;
                    t.sections = {}
                    for (let key in r.data.SECTIONS) {
                        let value = r.data.SECTIONS[key];
                        if (typeof t.sectionCss[key] !== "undefined") {
                            value['css'] = 'events__filter--' + t.sectionCss[key];
                        } else {
                            value['css'] = 'events__filter--' + value.XML_ID;
                        }
                        t.sections[key] = value;
                    }
                    t.dataLoaded = true;
                    t.initCurrent();
                })
                .catch((r) => {
                    if (Object.hasOwnProperty.call(r, 'error')) {
                        this.$showWarning(r['error'], true);
                    } else {
                        this.$showWarning('Ошибка при загрузке данных календаря', true);
                    }
                });
        },
        formSubscribeHandler(form) {
            this.$hideMessage();
            const t = this;

            axios.request({
                method: 'post',
                url: '/ajax_new/events.php',
                params: {
                    'action': 'addSubscriber',
                    'sessid': this.sessid,
                    'EMAIL': form.elements.email.value,
                    'PD_AGREED': form.elements.pdAgreed.checked,
                    'ADVERT_AGREED': form.elements.advertAgreed.checked,
                },
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                responseType: 'json',
            }).then((r) => {
                if (!r['data'] || r.data.result !== 'success') {
                    let msg = 'Ошибка при добавлении в подписку';
                    if (r['data'] && r.data.message !== undefined) {
                        msg = r.data.message;
                    }
                    t.$showWarning(msg, true);
                } else {
                    t.$showSuccess('Вы подписались на рассылку', true);
                }
            });
            return false;
        },
        iCall() {
            if (this.ids.length) {
                let url = '';
                this.ids.forEach(function (id) {
                    if (url) {
                        url += '&';
                    }
                    url += 'events[]=' + id;
                });
                url = '/events/ical/?' + url;
                window.open(url);
            } else {
                this.$showWarning('Нет событий для добавления', true);
            }
            return false;
        },
        setFilter(id) {
            if (this.filter.includes(id)) {
                for (let index in this.filter) {
                    if (this.filter[index] === id) {
                        this.$delete(this.filter, index);
                    }
                }
            } else {
                this.filter.push(id);
            }
            this.initCurrent();
        },
        resetFilter() {
            this.filter = [];
            this.initCurrent();
        },
        loadEvent(eventId) {
            $('.calendar__modal').arcticmodal();
            this.detailLoaded = false;

            let params = {
                eventId: eventId,
                sessid: BX.bitrix_sessid()
            };

            const t = this;
            this.$api.request(this.apiUrl, 'get', params)
                .then((r) => {
                    t.detailEvent = r.data;
                    t.detailLoaded = true;
                })
                .catch((r) => {
                    if (Object.hasOwnProperty.call(r, 'error')) {
                        this.$showWarning(r['error'], true);
                    } else {
                        this.$showWarning('Ошибка при загрузке события календаря', true);
                    }
                });
        }
    }
}